























































import { Component, Vue } from 'vue-property-decorator'
import REPORT_COLUMNS from '@/config/reportForm/column-config/sale-summary-details'
import { setSessionStorage } from '../../../store/src/utils/index'
@Component
export default class Login extends Vue {
	private reportFormId: string = 'XSMX_100002'
	private settingCols: any = REPORT_COLUMNS
	private gridData: any = []
	private hidecCols: string = ''
	private sumCol: any = {}
	private dateValue: any = []
	private billState: string = ''
	private mergeList: any = ['goodsSpec', 'toDate', 'fromDate']
	private filterFormData: any = {
		dateType: '0',
		restaurantName: '',
		fromOrganName: '',
		toOrganName: '',
		goodsName: '',
		organItemMergeFlag: false,
		billType: ''
	}
	private onChangeColData (hideCol: string) {
		this.hidecCols = hideCol
	}
	private async onSearch () {
		const searchFilter = await this.searchFilter('1')
		await this.searchHandler(searchFilter)
	}
	private searchFilter (ediExportParams?: string) {
		return new Promise((resolve: any) => {
			const settingMenuParams = this.settingCols.map((item) => {
			return item.prop
			})
			const params = {
				filters: {rules: this.getFiltersParams().filtersParams},
				rows: 30,
				page: 1,
				validcols: settingMenuParams.join(','),
				ediExportHideCols: ediExportParams
			}
			resolve(params)
		})
	}
	private searchHandler (params) {
		return new Promise((resolve: any) => {
			return (this as any).$fxHttp.requestPost({
				url: '/reportDateController/getXSMX100002Data',
				data: params
			}).then((res: any) => {
				this.setGridData(res)
				resolve()
			})
		})
	}
	private onExport () {
		this.exportFun()
	}
	private async exportFun () {
		const hideCols = this.hidecCols
		const searchFilter = await this.searchFilter(hideCols)
		const searchHandler = await this.searchHandler(searchFilter)
		await this.exportHandler(searchHandler)
	}
	private exportHandler (params) {
		window.open('/cldEdi/reportDateController/exportEdiDataCommon.do?exportType=2')
	}
	private onSortChange ({ prop, order }) {
		const settingMenuParams = this.settingCols.map((item) => {
			return item.prop
		})
		const params = {
			filters: {rules: this.getFiltersParams().filtersParams},
			rows: 30,
			page: 1,
			validcols: settingMenuParams.join(','),
			sord: prop === null ? null : order === 'ascending' ? 'asc' : 'desc',
			sidx: prop
		}
		return new Promise((resolve: any) => {
			return (this as any).$fxHttp.requestPost({
				url: '/reportDateController/getXSMX100002Data',
				data: params
			}).then((res: any) => {
				this.setGridData(res)
				resolve()
			})
		})
	}
	private setGridData (gridObj) {
		this.gridData = gridObj.currentData || []
		this.sumCol = gridObj.userdata || {}
	}
	private created () {
		setSessionStorage('titleLabel', '销售汇总表')
		this.initFilters()
	}
	private initFilters () {
		this.dateValue = [(this as any).$fxCommon.orderFilterStartDate(), (this as any).$fxCommon.orderFilterEndDate()]
	}
	private getFiltersParams () {
		const filtersParams = [] as any
		if (this.filterFormData.dateType !== '') {
			const billState = { field: 'date_type', data: this.filterFormData.dateType, op: 'eq' }
			filtersParams.push(billState)
		}
		if (this.filterFormData.restaurantName) {
			const restaurantName = { field: 'restaurant_name', data: this.filterFormData.restaurantName, op: 'cn' }
			filtersParams.push(restaurantName)
		}
		if (this.filterFormData.fromOrganName) {
			const fromOrganName = { field: 'from_organ_name', data: this.filterFormData.fromOrganName, op: 'cn' }
			filtersParams.push(fromOrganName)
		}
		if (this.filterFormData.toOrganName) {
			const toOrganName = { field: 'to_organ_name', data: this.filterFormData.toOrganName, op: 'cn' }
			filtersParams.push(toOrganName)
		}
		if (this.filterFormData.goodsName) {
			const goodsName = { field: 'goods_name', data: this.filterFormData.goodsName, op: 'cn' }
			filtersParams.push(goodsName)
		}
		if (this.filterFormData.organItemMergeFlag) {
			const organItemMergeFlag = { field: 'organ_item_merge_flag', data: '1', op: 'eq' }
			filtersParams.push(organItemMergeFlag)
		}
		if (this.filterFormData.billType) {
			const billType = { field: 'bill_type', data: this.filterFormData.billType, op: 'eq' }
			filtersParams.push(billType)
		}
		if (this.dateValue === '' ||
			this.dateValue === null ||
			this.dateValue === undefined) {
			filtersParams.push(
				{ field: 'bus_date', data: `${(this as any).$fxCommon.orderFilterStartDate()} 00:00`, op: 'ge' },
				{ field: 'bus_date', data: `${(this as any).$fxCommon.orderFilterEndDate()} 23:59`, op: 'le' }
			)
		} else {
			filtersParams.push(
				{ field: 'bus_date', data: `${this.dateValue[0]} 00:00`, op: 'ge' },
				{ field: 'bus_date', data: `${this.dateValue[1]} 23:59`, op: 'le' }
			)
		}
		return {
			filtersParams
		}
	}
	private changeMerge (val) {
		if (!val) {
			this.settingCols = REPORT_COLUMNS
		} else {
			this.settingCols = REPORT_COLUMNS.filter((i) => {
				return !this.mergeList.includes(i.prop)
			})
		}
	}
}
